import { useTranslation } from "react-i18next";
import AppLink from "../router/app-link";
import Button from "../tailwind/button";

export interface IPreorderServiceProps {
  preOrderedServiceTitle?: string;
  hasNoRemindTraffic: boolean;
  onActivate: () => void;
  statusCode: number; 
}

export default function PreorderService({
  preOrderedServiceTitle,
  hasNoRemindTraffic,
  onActivate,
  statusCode,
}: IPreorderServiceProps) {
  const { t } = useTranslation();

  if (statusCode === 1 || statusCode === 11) {
    return (
      <Button className="mx-0 btn-xs btn-primary">
        <AppLink to="/purchase/service">
          {t("Dashboard.PreorderService.PurchaseService")}
        </AppLink>
      </Button>
    );
  }

  return preOrderedServiceTitle ? (
    <>
      {preOrderedServiceTitle}{" "}
      {hasNoRemindTraffic && (
        <Button className="mx-0 btn-xs btn-primary" onClick={onActivate}>
          {t("Dashboard.PreorderService.Activate")}
        </Button>
      )}
    </>
  ) : (
    <Button className="mx-0 btn-xs btn-primary">
      <AppLink to="/purchase/service">
        {t("Dashboard.PreorderService.PurchasePreorderService")}
      </AppLink>
    </Button>
  );
}
